'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 21.982V4.272c0-.56.193-1.04.577-1.44.384-.4.864-.592 1.44-.576h3.24V.744c0-.208.072-.384.216-.528A.718.718 0 0 1 6 0c.208 0 .384.072.528.216.144.144.216.32.216.528v1.512h4.512V.744c0-.208.072-.384.216-.528A.718.718 0 0 1 12 0c.208 0 .384.072.528.216.144.144.216.32.216.528v1.512h4.512V.744c0-.208.072-.384.216-.528A.718.718 0 0 1 18 0c.208 0 .384.072.527.216.144.144.216.32.216.528v1.512h3.24c.56 0 1.04.192 1.44.576.4.384.592.864.576 1.44v17.71c0 .56-.192 1.04-.576 1.44-.384.4-.864.592-1.44.576H2.017c-.56 0-1.04-.192-1.44-.576-.4-.384-.592-.864-.576-1.44Zm1.513 0c0 .16.04.288.12.384.08.096.208.144.384.144h19.966c.16 0 .288-.048.384-.144a.45.45 0 0 0 .12-.384V4.272a.58.58 0 0 0-.12-.384c-.08-.096-.208-.144-.384-.144h-3.24v1.512a.718.718 0 0 1-.216.528A.718.718 0 0 1 18 6a.718.718 0 0 1-.528-.216.718.718 0 0 1-.216-.528V3.744h-4.512v1.512a.718.718 0 0 1-.216.528A.718.718 0 0 1 12 6a.718.718 0 0 1-.528-.216.718.718 0 0 1-.216-.528V3.744H6.744v1.512a.718.718 0 0 1-.216.528A.718.718 0 0 1 6 6a.718.718 0 0 1-.527-.216.718.718 0 0 1-.216-.528V3.744h-3.24a.519.519 0 0 0-.384.144.45.45 0 0 0-.12.384v17.71Zm3.744-3.24v-2.255h3v2.256h-3Zm0-3.743v-2.256h3v2.256h-3Zm0-3.744V9h3v2.256h-3Zm5.255 7.488v-2.256h3v2.256h-3Zm0-3.744v-2.256h3v2.256h-3Zm0-3.744V9h3v2.256h-3Zm5.232 7.488v-2.256h3v2.256h-3Zm0-3.744v-2.256h3v2.256h-3Zm0-3.744V9h3v2.256h-3Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
});
var CalendarDetailed = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.CalendarDetailed = CalendarDetailed;